import React from 'react';
import classnames from 'classnames';
import { element, node, oneOfType, arrayOf } from 'prop-types';
import { VBOX } from './vbox';
import Toolbar, { ToolbarRow, ToolbarSection } from '../toolbar';
import { ALIGN_START, ALIGN_END } from '../toolbar/section';

const Main = ({
  title,
  tools,
  className,
  toolbar,
  children,
}) => (
  <main
    className={classnames(
      VBOX,
      className,
    )}
  >
    {title && (
      <Toolbar className="main-toolbar">
        <ToolbarRow>
          <ToolbarSection align={ALIGN_START} shrink>
            <span className="mdc-toolbar__title">
              {title}
            </span>
          </ToolbarSection>
          <ToolbarSection align={ALIGN_END} >
            {tools}
          </ToolbarSection>
        </ToolbarRow>
        {toolbar}
      </Toolbar>
    )}
    <div className="content">
      {children}
    </div>
  </main>
);

Main.propTypes = {
  title: oneOfType([element, arrayOf(element)]),
  toolbar: element,
  children: node.isRequired,
};

Main.defaultProps = {
  title: null,
  toolbar: null,
};

export default Main;
